import React from "react";
import { useFilters, useGlobalFilter, useSortBy, useTable } from "react-table";
import MuiTable from "@material-ui/core/Table";
import {
    LinearProgress,
    Paper,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useTheme,
} from "@material-ui/core";
import { generalFilter, useDefaultColumn } from "../../../util/filter";
import { useStatusView } from "../projectManagementQueries";

export const StatusViewTable = ({ reportId }: any) => {
    const theme = useTheme();
    const defaultColumn = useDefaultColumn();


    const {
        data: statusViewdata,
        isLoading: isLoadingStatusView,
        isError: isStatusViewError,

    } = useStatusView(reportId);

    const columns: any[] = React.useMemo(
        () => [
            {
                Header: "Unit Serial Number",
                accessor: "unit_serial_number",
                filter: generalFilter,
                Cell: ({ value }: any) => <>{value || "N/A"}</>,

            },
            {
                Header: "Execution Group",
                accessor: "execution_group_name",
                filter: generalFilter,
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>,
            },
            {
                Header: "Procedure Definition",
                accessor: "procedure_definition_name",
                filter: generalFilter,
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>,
            },
            {
                Header: "Message",
                accessor: "message",
                filter: generalFilter,
                Cell: ({ value }: any) => <>{value ? value : "N/A"}</>,
            },
            
        ],
        []
    );

    const { getTableProps, headerGroups, rows, prepareRow } = useTable(
        {
            data: statusViewdata || [],
            columns,
            defaultColumn,
        },
        useFilters,
        useGlobalFilter,
        useSortBy
    );

    if (isLoadingStatusView) {
        return <LinearProgress />
    }

    if (
        statusViewdata &&
        statusViewdata.length > 0 &&
        statusViewdata[0].is_factory_witness === true
    ) {
        return (
            <Typography variant="body1" style={{ color: "red" }}>
                {statusViewdata[0].message}
            </Typography>
        );
    }

    return (
        <TableContainer
            component={Paper}
            style={{
                ...theme.tableContainer,
                maxHeight: "400px",
                overflowX: "auto",
                overflowY: "auto",
            }}
        >
            <MuiTable stickyHeader {...getTableProps()} size="small">
                <TableHead>
                    {headerGroups.map((headerGroup) => (
                        <TableRow {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <TableCell
                                    {...column.getHeaderProps()}
                                    style={{
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        height:"60px"
                                    }}
                                >
                                    {column.render("Header")}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableHead>
                <TableBody>
                    {rows.map((row) => {
                        prepareRow(row);
                        return (
                            <TableRow {...row.getRowProps()}>
                                {row.cells.map((cell) => (
                                    <TableCell
                                        {...cell.getCellProps()}
                                        style={{ textAlign: "center",height:"60px" }}
                                    >
                                        {cell.render("Cell")}
                                    </TableCell>
                                ))}
                            </TableRow>
                        );
                    })}
                </TableBody>
            </MuiTable>
        </TableContainer>
    );
};

